module.exports = __webpack_public_path__ + "static/media/min2.4b1642d7.png";